<template>
	<div id="home">
		<div class="container">
			<!-- <div class="companyInfo">
				<div class="company_avatar">
					<img v-if="schoolInfo.logo" :src="schoolInfo.logo"></img>
					<div class="company_name" v-else>
						{{schoolInfo.company_name?schoolInfo.company_name.substring(0,1):''}}
					</div>
				</div>
				<div class="companyInfoRight">
					<div class="companyInfoName">
						{{ schoolInfo.company_name || '校招平台用户' }}
					</div>
					<div class="tags">
						<div class="item" v-if="schoolInfo.industry">
							{{schoolInfo.industry || ''}}
						</div>
						<div class="item" v-if="schoolInfo.scale">
							{{schoolInfo.scale || ''}}
						</div>
					</div>
				</div>
			</div> -->
			<div class="banner">
				<!-- <img src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/10/10/dy1111.png" alt="" @click="goSign" /> -->
				<img src="https://oss.sx985.com/2025/10/10/xxxioureq1.png" alt=""
					@click="goSign" />
				<!-- download1 -->
				<!-- <div class="pdf" @click="">
					
				</div> -->
			</div>


			<div class="inCommonUse">
				<div class="title head-title">
					常用功能
					<!-- <img @click="goSign"
						src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/10/10/aaaryu.png" alt=""> -->
					<div class="documentButton">
						<div class="activityIntroductionText">活动介绍：</div>
						<div class="activityAction schoolLink" @click.stop="$router.push('/activityIntroduction')">
							<img src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/06/05/iio1.png" alt="" />
							<span>高校链接</span>
						</div>
						<a class="activityAction documentLink" href="https://www.sx985.com/千校万企联合促就业活动介绍.pdf" target="_blank" rel="noopener">
							<img src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/06/05/iio2.png" alt="" />
							<span>文档</span>
						</a>
						<div class="activityAction videoLink" @click="videoDialogVisible = true">
							<img src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/06/05/iio3.png" alt="" />
							<span>视频</span>
						</div>
					</div>
				</div>
				<div class="optionContainer">
					<div class="itemContainer">


						<div class="functionality bg1" @click="toCorporateImage">
							<div class="left">
								<img src="../img/index1.png" style="height: 37px;" alt="" />
								<div class="">
									企业主页
								</div>
							</div>
							<div class="right">
								<div class="">
									点击查看
								</div>
								<img src="../img/more3.png" alt="" />
							</div>
						</div>
						<div class="functionality" @click="toPushMessage">
							<div class="left">
								<img src="../img/index4.png" style="height: 36px;" alt="" />
								<div class="">
									职位发布
								</div>
							</div>
							<div class="right">
								<div class="">
									点击查看
								</div>
								<img src="../img/more3.png" alt="" />
							</div>
						</div>
						<!-- <div class="functionality bg2" @click="toCommentManagement">
							<img src="../img/index2.png" style="height: 47px;" alt="" />
							<div class="">
								评论管理
							</div>
						</div> -->
						<div class="functionality bg2" @click="toCommentManagement">
							<div class="left">
								<img src="../img/index2.png" style="height: 35px;" alt="" />
								<div class="">
									评论管理
								</div>
							</div>
							<div class="right">
								<div class="">
									点击查看
								</div>
								<img src="../img/more3.png" alt="" />
							</div>
						</div>
						<!-- <div class="functionality bg3" @click="toLiveManagement">
							<img src="../img/index9.png" style="height: 48px;" alt="" />
							<div class="">
								直播管理
							</div>
						</div> -->
						<div class="functionality bg3" @click="toLiveManagement">
							<div class="left">
								<img src="../img/index9.png" style="height: 36px;" alt="" />
								<div class="">
									双选会
								</div>
							</div>
							<div class="right">
								<div class="">
									点击查看
								</div>
								<img src="../img/more3.png" alt="" />
							</div>
						</div>



						<!-- <img src="../img/inCommonUse1.png" @click="toPushMessage" alt="" />
						<img src="../img/inCommonUse2.png" @click="toCorporateImage" alt="" />
						<img src="../img/inCommonUse3.png" @click="toCommentManagement" alt="" />
						<img src="../img/inCommonUse4.png" alt="" @click="toLiveManagement" /> -->
					</div>

					<!-- <el-popover placement="right" trigger="hover">
						<div class="qrCode">
							<div class="qrCodeHint">
								<div>扫</div>
								<div>码</div>
								<div>使</div>
								<div>用</div>
								<div>生</div>
								<div>源</div>
								<div>库</div>
								<img src="../img/triangle.png" alt="" />
							</div>
							<img :src="qrcodeImg" alt="" class="qrCodeImage" />
						</div>
						<img :src="qrcodeImg" slot="reference" alt="" style="width: 120px;height: 120px;"
							v-show='qrcodeImg' />
					</el-popover> -->

					<!-- <div class="qrCode" v-if="qrcodeImg">
						<div class="qrCodeHint">
							<div>扫</div>
							<div>码</div>
							<div>使</div>
							<div>用</div>
							<div>生</div>
							<div>源</div>
							<div>库</div>
							<img src="../img/triangle.png" alt="" />
						</div>
						<img :src="qrcodeImg" alt="" class="qrCodeImage" />
					</div> -->

				</div>

			</div>


			<div class="listContainer">
				<div class="screen">
					<div class="search">
						<div class="title">
							在线招聘
						</div>
						<div class="searchBox">
							<div class="searchLeft">
								<img src="../img/search2.png" alt="" />
								<input type="text" v-model="searchName" placeholder="可按姓名、学校、专业等搜索生源" />
							</div>
							<div class="searchRight" @click="search">
								搜索
							</div>
						</div>
					</div>


					<div class="screenContainer">
						<div class="searchContainer">

							<div class="searchItem searchItem-p">
								<div class="iptName iptName-l">
									意向职位：
								</div>
								<div class="majorbox" @click="selectcityBox5">
									<div class="majorBox one-line" :style="job_title.length>0?'':'color:#c0c4cc;'">
										{{job_title.length>0?job_title.join('，'):'请选择意向职位'}}
									</div>
									<i class="el-icon-arrow-down" style="color:#c0c4cc;"></i>
								</div>
							</div>


							<div class="searchItem">
								<div class="iptName">
									学校层次：
								</div>
								<div class="majorbox" @click="selectcityBox3">
									<div class="majorBox one-line"
										:style="academy_feature.length>0?'':'color:#c0c4cc;'">
										{{academy_feature.length>0?academy_feature.join('，'):'请选择学校层次'}}
									</div>
									<i class="el-icon-arrow-down" style="color:#c0c4cc;"></i>
								</div>
							</div>
							<div class="searchItem">
								<div class="iptName">
									专业要求：
								</div>
								<div class="majorbox" @click="selectMajorBox">
									<div class="majorBox one-line" :style="major_name.length>0?'':'color:#c0c4cc;'">
										{{major_name.length>0?major_name.join('，'):'请选择专业要求'}}
									</div>
									<i class="el-icon-arrow-down" style="color:#c0c4cc;"></i>
								</div>
							</div>



						</div>
						<div class="">
							<el-collapse-transition>
								<div class="searchContainer" v-show="ispackUp">

									<div class="searchItem searchItem-p">
										<div class="iptName iptName-l">
											学生性别：
										</div>
										<el-select v-model="gender" @change='genderChange' clearable
											placeholder="请选择学生性别">
											<el-option v-for="(item,index) in options" :key="index" :label="item.label"
												:value="item.value">
											</el-option>
										</el-select>
									</div>


									<div class="searchItem">
										<div class="iptName">
											学历要求：
										</div>
										<!-- <div class="majorbox" @click="selectcityBox4">
											<div class="majorBox one-line" :style="education.length>0?'':'color:#c0c4cc;'">
												{{education.length>0?education.join('，'):'请选择学历要求'}}
											</div>
											<i class="el-icon-arrow-down" style="color:#c0c4cc;"></i>
										</div> -->
										<el-select v-model="education" multiple clearable placeholder="请选择学历要求">
											<el-option v-for="(item,index) in intrdustry_1" :key="index"
												:label="item.intr_name" :value="item.intr_name">
											</el-option>
										</el-select>
									</div>

									<div class="searchItem">
										<div class="iptName">
											学校所在城市：
										</div>
										<div class="majorbox" @click="selectcityBox">
											<div class="majorBox one-line"
												:style="city_name.length>0?'':'color:#c0c4cc;'">
												{{city_name.length>0?city_name.join('，'):'请选择学校所在城市'}}
											</div>
											<i class="el-icon-arrow-down" style="color:#c0c4cc;"></i>
										</div>
									</div>

									<!-- <div class="searchItem">
										<div class="majorbox" @click="selectcityBox">
											<div class="majorBox one-line"
												:style="city_name.length>0?'':'color:#c0c4cc;'">
												{{city_name.length>0?city_name.join('，'):'学校所在城市'}}
											</div>
											<i class="el-icon-arrow-down" style="color:#c0c4cc;"></i>
										</div>
									</div> -->





									<div class="searchItem searchItem-p">
										<div class="iptName iptName-l">
											求职意向：
										</div>
										<el-select v-model="job_status" @change='genderChange' clearable
											placeholder="请选择求职意向">
											<el-option v-for="(item,index) in intention" :key="index"
												:label="item.intr_name" :value="item.value">
											</el-option>
										</el-select>
									</div>


									<div class="searchItem">
										<div class="iptName">
											毕业年份：
										</div>
										<el-select v-model="graduation_year" @change='genderChange' clearable
											placeholder="请选择毕业年份">
											<el-option v-for="(item,index) in graduationDateList" :key="index"
												:label="item.intr_name" :value="item.value">
											</el-option>
										</el-select>
									</div>

									<!-- <div class="searchItem">
										<div class="iptName">
											近期是否看过/聊过：
										</div>
										<el-select v-model="is_just_chat" @change='genderChange' clearable
											placeholder="请选择近期是否看过/聊过">
											<el-option v-for="(item,index) in isCommunication" :key="index"
												:label="item.intr_name" :value="item.value">
											</el-option>
										</el-select>
									</div> -->

									<div class="searchItem">
										<div class="iptName">
											学生所在学校：
										</div>
										<div class="majorbox" @click="selectcityBox1">
											<div class="majorBox one-line"
												:style="academy_name.length>0?'':'color:#c0c4cc;'">
												{{academy_name.length>0?academy_name.join('，'):'请选择学生所在学校'}}
											</div>
											<i class="el-icon-arrow-down" style="color:#c0c4cc;"></i>
										</div>
									</div>

									<div class="searchItem searchItem-p">
										<div class="iptName iptName-l">
											意向城市：
										</div>
										<div class="majorbox" @click="selectcityBox2">
											<div class="majorBox one-line"
												:style="work_city.length>0?'':'color:#c0c4cc;'">
												{{work_city.length>0?work_city.join('，'):'请选择意向城市'}}
											</div>
											<i class="el-icon-arrow-down" style="color:#c0c4cc;"></i>
										</div>
									</div>
								</div>
							</el-collapse-transition>
						</div>
						<div class="btnContainer">

							<div class="btn" style="background: #1E40AF;margin-right: 12px;" @click="search">
								<!-- <img src="../img/search.png" alt="" /> -->
								<div>
									筛选
								</div>
							</div>

							<div class="btn" style="background: #fff;border: 1px solid #DCDFE6;margin-right: 30px;"
								@click="screen">
								<!-- <img src="../img/screen.png" alt="" /> -->
								<div style="color: #333;">
									高级筛选
								</div>
							</div>

							<div class="reset" @click="reset">
								重置
							</div>

							<div class="packUp" @click="changeScreen">
								<div class="">
									{{ispackUp?'收起':'展开'}}
								</div>
								<i class="el-icon-arrow-down" style="color:#1E40AF;transition:.5s all;"
									:style="ispackUp?'transform: rotate(180deg);':'transform: rotate(360deg);'"></i>
							</div>
						</div>
					</div>
				</div>
				<!--  -->
				<div class="" v-loading="loading">
					<template v-if="recordList.length>0">
						<div class="list homeList">
							<div class="item" v-for="(item,index) in recordList" :key="index">
								<div class="" style="">
									<div class="studentInfo">
										<div class="right" style="position: relative;">
											<img v-if="getStudentAvatarUrl(item) && !avatarLoadFailed[getStudentAvatarKey(item, index)]"
												:src="getStudentAvatarUrl(item)"
												@error="handleStudentAvatarError(item, index)" alt="">
											<div v-else class="studentAvatarText"
												:class="`studentAvatarText--${getStudentAvatarColorIndex(item)}`">
												{{getStudentAvatarName(item)}}
											</div>
											<div class="shortVideo" v-if="item.filelist&&item.filelist.url">
												简历
											</div>
										</div>
										<div class="left">
											<div class="nameContainer">
												<div class="name" v-if="nextToken">
													{{item.realname || item.username || item.name }}
												</div>
												<div class="name" v-else>
													{{item.realname?item.realname.charAt(0)+'同学':item.username?item.username.charAt(0)+'同学':item.name?item.name.charAt(0)+'同学':''}}
												</div>
												<div class="other">
													{{item.gender===1?'男':'女'}} · {{item.age|replaceAge}} ·
													{{item.highest_education || '本科'}}{{item.graduation_year?' · '+item.graduation_year:''}}
												</div>
												<!-- item.level_name || '大四' -->
											</div>
										</div>
									</div>
									<div class="education one-line">
										<span v-if="item.academy_name || item.major_name">
											{{item.academy_name}}
											<span v-if="item.academy_name && item.major_name">·</span>
											{{item.major_name || ''}}
										</span>
										<span v-else>
											{{item.schoolName}}
											<span v-if="item.schoolName && item.department">·</span>
											{{item.department || ''}}
										</span>
									</div>
									<div class="intentionContainer">
										<div class="intentionitem " style="margin-bottom:5px;">
											<img src="../img/position.png" alt="" />
											<div class="one-line">
												求职期望：{{item.job_title?item.job_title.replace(/,/g,'，'):'暂无'}}
												<span v-if="item.salary_max || item.salary_min">
													{{' · '}}{{item.salary_min+'-'+item.salary_max+'k'}}
												</span>
												<span v-else>{{' · '}}面议</span>
											</div>
										</div>
									</div>
									<div class="skillTag" v-if="item.hobbyList">
										<div class="tagItem" v-for="(item,index) in item.hobbyList" :key="index">
											{{item}}
										</div>
									</div>

									<div class="briefIntroduction">
										<div class="briefIntroductionLeft two-line" v-if="item.personal_summary ">
											{{item.personal_summary | replaceNr}}
										</div>
                                        <div class="briefIntroductionLeft two-line" v-else>      
                                            {{item.skill | replaceNr}}
                                        </div>
										<!-- <div class="briefIntroductionRight" style="cursor: pointer;"
										@click="toInfo(item.id,item.source,item.user_id)">
										查看详情
									</div> -->
									</div>
								</div>
								<div class="briefIntroductionRight" style="cursor: pointer;"
									@click="toInfo(item.id,item.source,item.user_id)">
									查看详情
								</div>
							</div>
						</div>
						<div class="paging">
							<div class="pagingLeft" :style="total>12?'opacity:1':'opacity:0'">
								<el-button plain @click="previousPage" :disabled='currentpage==1'>上一页</el-button>
								<el-button plain @click="nextPage" :disabled='isNextPage'>下一页</el-button>
								<!-- <el-button type="danger" plain>删除</el-button> -->
							</div>
							<el-pagination background layout="prev, pager, next,jumper" :page-size='pageSizes'
								:total="total" @current-change='currentChange' :current-page='currentpage'>
							</el-pagination>
						</div>
					</template>

					<template v-else>
						<el-empty description="暂无数据"></el-empty>
					</template>
				</div>
			</div>

		</div>
		<el-dialog top="15vh !important" title="活动视频" :visible.sync="videoDialogVisible" width="800px" class="activityVideoDialog">
			<video v-if="videoDialogVisible" class="activityVideo" controls 
				src="https://video.sx985.com/sv/575049eb-1a012efa065/575049eb-1a012efa065.mp4"></video>
		</el-dialog>
		<div class="elDialogBox">

			<el-dialog title="高级筛选" :visible.sync="dialogVisible" width="650px" :before-close="handleClose">
				<div class="elDialog">

					<!-- <div class="searchItem" @click="selectcityBox5">
						<div class="iptName">
							意向职位
						</div>
						<div class="majorBox1 one-line" :style="job_title.length>0?'':'color:#c0c4cc;'">
							{{job_title.length>0?job_title.join('，'):'请选择'}}
						</div>
						<i class="el-icon-arrow-down" style="color:#c0c4cc;margin-right: 10px;"></i>
					</div>
					<div class="searchItem" @click="selectcityBox">
						<div class="iptName">
							学校所在城市
						</div>
						<div class="majorBox1 one-line" :style="city_name.length>0?'':'color:#c0c4cc;'">
							{{city_name.length>0?city_name.join('，'):'请选择'}}
						</div>
						<i class="el-icon-arrow-down" style="color:#c0c4cc;margin-right: 10px;"></i>
					</div>

					<div class="searchItem" @click="selectcityBox1">
						<div class="iptName">
							学生所在学校
						</div>
						<div class="majorBox1 one-line" :style="academy_name.length>0?'':'color:#c0c4cc;'">
							{{academy_name.length>0?academy_name.join('，'):'请选择'}}
						</div>

						<i class="el-icon-arrow-down" style="color:#c0c4cc;margin-right: 10px;"></i>
					</div>

					<div class="searchItem">
						<div class="iptName">
							是否应届
						</div>
						<el-select v-model="is_current_year" multiple placeholder="请选择">
							<el-option v-for="(item,index) in currentList" :key="index" :label="item.intr_name"
								:value="item.intr_name">
							</el-option>
						</el-select>
					</div>

					
					

					<div class="searchItem">
						<div class="iptName">
							求职意向
						</div>
						<el-select v-model="job_status" multiple placeholder="请选择">
							<el-option v-for="(item,index) in intention" :key="index" :label="item.intr_name"
								:value="item.intr_name">
							</el-option>
						</el-select>
					</div>

					<div class="searchItem" style="margin-bottom: 30px;" @click="selectcityBox2">
						<div class="iptName">
							意向城市
						</div>
						<div class="majorBox1 one-line" :style="work_city.length>0?'':'color:#c0c4cc;'">
							{{work_city.length>0?work_city.join('，'):'请选择'}}
						</div>

						<i class="el-icon-arrow-down" style="color:#c0c4cc;margin-right: 10px;"></i>
					</div> -->

					<!-- <div class="advanced">
						
					</div >-->
					<div class="searchItem">
						<div class="iptName">
							近期是否看过/聊过
						</div>
						<el-select v-model="is_just_chat" placeholder="请选择">
							<el-option v-for="(item,index) in isCommunication" :key="index" :label="item.intr_name"
								:value="item.intr_name">
							</el-option>
						</el-select>
					</div>


					<div class="searchItem">
						<div class="iptName">
							实习/项目经历
						</div>
						<el-select v-model="is_practice_experience" placeholder="请选择">
							<el-option v-for="(item,index) in option1" :key="index" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
					<div class="searchItem">
						<div class="iptName">
							校园活动经历/获奖/资格证书
						</div>
						<el-select v-model="is_social_experience" placeholder="请选择">
							<el-option v-for="(item,index) in option1" :key="index" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>


					</div>
					<div class="searchItem" @click="selectcityBox6">
						<div class="iptName">
							个人技能与兴趣
						</div>
						<!-- <el-select v-model="is_skill_hobby" multiple placeholder="请选择">
							<el-option v-for="(item,index) in multipleSelect10" :key="index" :label="item"
								:value="item">
							</el-option>
						</el-select> -->
						<div class="majorBox1 one-line" :style="is_skill_hobby.length>0?'':'color:#c0c4cc;'">
							{{is_skill_hobby.length>0?is_skill_hobby.join('，'):'请选择'}}
						</div>
						<i class="el-icon-arrow-down" style="color:#c0c4cc;margin-right: 10px;"></i>
					</div>
					<div class="searchItem">
						<div class="iptName">
							加班接受度
						</div>
						<el-select v-model="acceptance_of_overtime" placeholder="请选择">
							<el-option v-for="(item,index) in multipleSelect3" :key="index" :label="item.name"
								:value="item.name">
							</el-option>
						</el-select>
					</div>
					<div class="searchItem">
						<div class="iptName">
							出差接受度
						</div>
						<el-select v-model="acceptance_of_outwork" placeholder="请选择">
							<el-option v-for="(item,index) in multipleSelect4" :key="index" :label="item.name"
								:value="item.name">
							</el-option>
						</el-select>
					</div>
					<div class="" style="font-weight: 400;font-size: 14px;color: #343232;">
						求职者最擅长的团队定位（按以下项目从高到低拖动排序）
					</div>
					<div class="drag">
						<section class="content">
							<draggable v-model="ques1" animation="400" @chang="change" @start="start" :move="move"
								@end="end">
								<!-- 列表样式 -->
								<div v-for="(item, index) in ques1" :key=index class="row">
									<span>{{ item.name }}</span>
									<!-- <span>（{{ item.id }}）</span> -->
								</div>
							</draggable>
						</section>
					</div>

					<div class="" style="font-weight: 400;font-size: 14px;color: #343232;">
						求职者最看重哪些回报?（按以下项目从高到低拖动排序）
					</div>
					<div class="drag">
						<section class="content">
							<draggable v-model="ques2" animation="400" @chang="change1" @start="start1" :move="move1"
								@end="end1">
								<!-- 列表样式 -->
								<div v-for="(item, index) in ques2" :key=index class="row">
									<span>{{ item.name }}</span>
									<!-- <span>（{{ item.id }}）</span> -->
								</div>
							</draggable>
						</section>
					</div>

					<div class="btnContainer1">
						<!-- <el-button type="primary">公司预览</el-button> -->
						<el-button type="primary" @click="search">确定</el-button>
					</div>
				</div>
			</el-dialog>
		</div>

		<el-dialog title="专业要求" ref="multipleChoice" :visible.sync="dialogVisibleMultipleChoice"
			:before-close="handleClose" @open='multipleOpen' @close='multipleClose' width="800px">
			<multipleChoice @submit='multiple' @cancel='cancel' :selectList='major_name'
				:multipleChange='multipleChange'></multipleChoice>
		</el-dialog>

		<el-dialog title="学校所在城市" ref="multipleChoice1" :visible.sync="dialogVisibleMultipleChoice1"
			:before-close="handleClose" @open='multipleOpen' @close='multipleClose' width="800px">
			<multipleChoice1 @submit='multiple1' @cancel='cancel' :selectList='city_name'
				:multipleChange='multipleChange'></multipleChoice1>
		</el-dialog>

		<!-- <el-dialog title="选择城市" :visible.sync="dialogVisibleMultipleChoice1" :before-close="handleClose" width="800px">
			<multipleChoice1></multipleChoice1>
		</el-dialog> -->

		<!-- <el-dialog title="选择学校" :visible.sync="dialogVisibleMultipleChoice2" :before-close="handleClose" width="800px">
			<multipleChoice2></multipleChoice2>
		</el-dialog> -->

		<el-dialog title="学生所在学校" ref="multipleChoice2" :visible.sync="dialogVisibleMultipleChoice2"
			:before-close="handleClose" @open='multipleOpen' @close='multipleClose' width="800px">
			<multipleChoice2 @submit='multiple2' @cancel='cancel' :selectList='academy_name'
				:multipleChange='multipleChange'></multipleChoice2>
		</el-dialog>

		<el-dialog title="意向城市" ref="multipleChoice1" :visible.sync="dialogVisibleMultipleChoice3"
			:before-close="handleClose" @open='multipleOpen' @close='multipleClose' width="800px">
			<multipleChoice1 @submit='multiple3' @cancel='cancel' :selectList='work_city'
				:multipleChange='multipleChange'></multipleChoice1>
		</el-dialog>

		<el-dialog title="学校层次" ref="multipleChoice3" :visible.sync="dialogVisibleMultipleChoice4"
			:before-close="handleClose" @open='multipleOpen' @close='multipleClose' width="800px">
			<multipleChoice3 @searchWord="searchWord" @submit='multiple4' @cancel='cancel' :selectList='academy_feature'
				:multipleChange='multipleChange'>
			</multipleChoice3>
		</el-dialog>


		<el-dialog title="学历要求" ref="multipleChoice4" :visible.sync="dialogVisibleMultipleChoice5"
			:before-close="handleClose" @open='multipleOpen' @close='multipleClose' width="800px">
			<multipleChoice4 @submit='multiple5' @cancel='cancel' :selectList='education'
				:multipleChange='multipleChange'></multipleChoice4>
		</el-dialog>

		<el-dialog title="意向职位" ref="multipleChoice5" :visible.sync="dialogVisibleMultipleChoice6"
			:before-close="handleClose" @open='multipleOpen' @close='multipleClose' width="800px">
			<multipleChoice5 @submit='multiple6' @cancel='cancel' :selectList='job_title'
				:multipleChange='multipleChange'></multipleChoice5>
		</el-dialog>

		<el-dialog title="个人技能与兴趣" ref="multipleChoice6" :visible.sync="dialogVisibleMultipleChoice7"
			:before-close="handleClose" @open='multipleOpen' @close='multipleClose' width="800px">
			<multipleChoice7 @submit='multiple7' @cancel='cancel' :selectList='is_skill_hobby'
				:multipleChange='multipleChange'></multipleChoice7>
		</el-dialog>
	</div>
</template>
<script>
    const config = require('../../WebConfig')
	import {
		mapMutations,
		mapState
	} from 'vuex'
	import draggable from 'vuedraggable'
	import multipleChoice from '../components/multipleChoice.vue'
	import multipleChoice1 from '../components/multipleChoice1.vue'
	import multipleChoice2 from '../components/multipleChoice2.vue'
	import multipleChoice3 from '../components/multipleChoice3.vue'
	import multipleChoice4 from '../components/multipleChoice4.vue'
	import multipleChoice5 from '../components/multipleChoice5.vue'
	import multipleChoice7 from '../components/multipleChoice7.vue'
	export default {
		title: '校招平台-大学生校园招聘-应届生求职就业信息网',
		meta: [{
				name: 'description',
				content: '专业校招信息服务平台，实时更新全国企业校园招聘、春招秋招、高校宣讲会、应届生实习岗位，助力大学生、毕业生快速找到优质工作，一站式校园求职招聘网站。'
			},
			{
				name: 'keywords',
				content: '校招平台,校园招聘,应届生求职,大学生校招,毕业生就业,春招,秋招,高校招聘,实习求职'
			}
		],
		components: {
			draggable,
			multipleChoice,
			multipleChoice1,
			multipleChoice2,
			multipleChoice3,
			multipleChoice4,
			multipleChoice5,
			multipleChoice7,
		},
		data() {
			return {
				videoDialogVisible: false,
				multipleChange: false,
				avatarLoadFailed: {},
				dialogVisibleMultipleChoice: false,
				dialogVisibleMultipleChoice1: false,
				dialogVisibleMultipleChoice2: false,
				dialogVisibleMultipleChoice3: false,
				dialogVisibleMultipleChoice4: false,
				dialogVisibleMultipleChoice5: false,
				dialogVisibleMultipleChoice6: false,
				dialogVisibleMultipleChoice7: false,
				options: [{
					value: '-1',
					label: '全部'
				}, {
					value: '1',
					label: '男'
				}, {
					value: '2',
					label: '女'
				}],
				value: '',

				colorList: ['#FFF4EC', '#fffff6', '#EFFEFE'],

				total: 100,
				pageSizes: 12,
				currentPage: 1,
				currentpage: 1,
				college_type_list: [{
					catalog_name: '学校分类',
					majors: [{
							name: "双一流",
							isSelect: false,
						},
						{
							name: "C9",
							isSelect: false,
						},
						{
							name: "E9",
							isSelect: false,
						},
						{
							name: "985",
							isSelect: false,
						},
						{
							name: "211",
							isSelect: false,
						},
						{
							name: "国防七子",
							isSelect: false,
						},
						{
							name: "建筑老八校",
							isSelect: false,
						},
						{
							name: "建筑新八校",
							isSelect: false,
						},
						{
							name: "两电一邮",
							isSelect: false,
						},
						{
							name: "五院四系",
							isSelect: false,
						},
						{
							name: "八大美院",
							isSelect: false,
						}
					]
				}],
				//学校层次
				intrdustry_10: [{
						intr_name: "双一流"
					},
					{
						intr_name: "C9"
					},
					{
						intr_name: "E9"
					},
					{
						intr_name: "985"
					},
					{
						intr_name: "211"
					},
					{
						intr_name: "国防七子"
					},
					{
						intr_name: "建筑老八校"
					},
					{
						intr_name: "建筑新八校"
					},
					{
						intr_name: "两电一邮"
					},
					{
						intr_name: "五院四系"
					},
					{
						intr_name: "八大美院"
					}
				],
				majorList: [], //专业列表
				//学历要求
				intrdustry_1: [{
						intr_name: "大专"
					},
					{
						intr_name: "本科"
					},
					{
						intr_name: "硕士"
					},
					{
						intr_name: "博士"
					}
				],
				//意向职业
				jobTitleList: [],
				cityList: [],
				schoolList: [],
				currentList: [],
				isCommunication: [{
						intr_name: "是",
						value: '1',
					},
					{
						intr_name: "否",
						value: '2',
					}
				],
				intention: [{
						intr_name: "求职中",
						value: '1',
					},
					{
						intr_name: "观望机会",
						value: '2',
					}
				],
				option1: [{
					value: '1',
					label: '是'
				}, {
					value: '0',
					label: '否'
				}],

				multipleSelect10: ['读书', '绘画', '写作', '舞蹈', '篮球', '足球', '游泳', '健身', '骑行', '钓鱼', '旅游', '唱歌', '电子竞技', '网络主播',
					'知乎达人', '豆瓣达人', '抖音达人', '穿搭博主'
				], //个人技能与兴趣
				multipleSelect4: [{
						name: '高(经常)',
						secondName: '高',
						isSelect: false,
					},
					{
						name: '中等(偶尔)',
						secondName: '中等',
						isSelect: false,
					},
					{
						name: '低(不出差)',
						secondName: '低',
						isSelect: false,
					}
				],
				multipleSelect3: [{
						name: '高',
						isSelect: false,
					},
					{
						name: '中等',
						isSelect: false,
					},
					{
						name: '低',
						isSelect: false,
					}
				],

				academy_feature: [], //学校层次
				major_name: [], //专业要求
				education: [], //学历要求
				gender: '', //性别
				job_title: [], //意向职业
				city_name: [], //学校所在城市
				academy_name: [], //学生所在学校
				is_current_year: '', //是否应届
				is_just_chat: '', //近期是否聊过
				job_status: '', //求职意向
				work_city: [], //意向城市

				is_practice_experience: '1', //实习/项目经历
				is_social_experience: '1', //校园活动经历/获奖/资格证书
				is_skill_hobby: [], //个人技能与兴趣
				acceptance_of_overtime: '中等', //加班接受度
				acceptance_of_outwork: '中等(偶尔)', //出差接受度
				dialogVisible: false,


				ques1: [{
						name: '--开拓新业务:获得快速的结果、采取行动、喜好挑战',
						idx: 0,
						word: 'A'
					},
					{
						name: '--团队组织:热情乐观、采取行动、活跃团队气氛',
						idx: 1,
						word: 'B'
					},
					{
						name: '--运营优化:保证准确性、保持稳定性、对产品流程和细节精益求精',
						idx: 2,
						word: 'C'
					},
					{
						name: '--稳定执行:给予他人支持、团队精神、吃苦耐劳',
						idx: 3,
						word: 'D'
					},
				],
				ques2: [{
						name: '--有话语权的职位、晋升、高薪、荣誉感、胜利感',
						idx: 0,
						word: 'A'
					},
					{
						name: '--友好密切的同事关系、团建活动、展现才艺的机会',
						idx: 1,
						word: 'B'
					},
					{
						name: '--发挥专业特长、获取新知识、高质量的工作成果',
						idx: 2,
						word: 'C'
					},
					{
						name: '--稳定的环境、较少的冲突、诚挚的感谢、合作互助的氛围',
						idx: 3,
						word: 'D'
					}
				],

				recordList: [],

				qrcodeImg: '',
				loading: false,


				ispackUp: false,

				searchName: '',

				searchObj: {},

				graduationDateList: [],
				graduation_year: '',

				request: false
			}
		},
		filters: {
			replaceNr(val) { //替换空格
				if (val) {
					return val.replace(/[\r\n]+/gm, '')
				} else {
					return '暂无简介'
				}
			},
			replaceAge(val){
				if (val.indexOf('-') > -1) {
					let birthday = val
					let birth_year = birthday.substring(0, 4)
					let now_yaer = (new Date()).getFullYear()
					return  now_yaer - birth_year * 1 +'岁'
				}else{
					if(val){
						return val.replace('岁','')+'岁'
					}else{
						return 21+'岁'
					}
				}
				
			}
		},
		computed: {
			...mapState({
				nextToken: state => state.nextToken,
				userInfo: state => state.userInfo,
				schoolInfo: state => state.schoolData,
			}),
			isNextPage() {
				// total
				// pageSizes
				// currentpage
				console.log(this.currentpage)
				console.log(Math.ceil(this.total / this.pageSizes))
				if (this.currentpage == Math.ceil(this.total / this.pageSizes) || Math.ceil(this.total / this.pageSizes) ==
					0) {
					return true
				} else {
					return false
				}
			}
		},
		mounted() {
			this.searchName = ''
			this.getgraduationDate()
			this.getQrcode()
			this.getcatalogall()
			this.getCityList()
			this.remoteMethod()
			let arr = []

			if (this.schoolInfo && this.schoolInfo.job_title && this.schoolInfo.job_title.length > 0) {
				this.schoolInfo.job_title.forEach((item) => {
					if (arr.indexOf(item) == -1) {
						arr.push(item)
					}
				})
				this.jobTitleList = arr
				this.job_title = arr
				// this.searchObj.job_title = JSON.stringify(this.jobTitleList)
			}
			this.getUserRecordList()
			// this.$util.post(
			// 	"/login/login", {
			// 		username: this.ruleForm.username,
			// 		password: this.$md5(this.ruleForm.pass),
			// 	},
			// 	(res) => {
			// 		
			// 		if (res.code == 1) {
			// 			localStorage.setItem("token", res.data.token);
			// 			this.$router.push({
			// 				path: "/main",
			// 				// query: {
			// 				//   id: 1,
			// 				// },
			// 			});
			// 		}
			// 	}
			// );


			this.modifySource()
			// this.getQrcode1()
		},
		methods: {
			...mapMutations(['setIslogin']),
			getStudentAvatarKey(item, index) {
				return `${item.user_id || item.id || 'student'}-${index}`
			},
			getStudentAvatarUrl(item) {
				if (item.avatar) return item.avatar

				const userId = String(item.user_id || item.id || '')
				const lastDigit = userId.slice(-1)
				const userIdNumber = Number(userId)
				if (!/^\d$/.test(lastDigit) || Number(lastDigit) < 4 || !Number.isFinite(userIdNumber)) {
					return ''
				}

				const baseUrl = 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/01/05'
				if (Number(item.gender) === 2) return `${baseUrl}/nv${userIdNumber % 25}.png`
				if (Number(item.gender) === 1) return `${baseUrl}/nan${userIdNumber % 21}.png`
				return `${baseUrl}/wu${userIdNumber % 9}.png`
			},
			getStudentAvatarName(item) {
				return String(item.realname || item.username || item.name || '').slice(-2)
			},
			getStudentAvatarColorIndex(item) {
				const name = String(item.realname || item.username || item.name || '')
				let colorIndex = 0
				for (let index = 0; index < name.length; index += 1) {
					colorIndex = (colorIndex + name.charCodeAt(index)) % 5
				}
				return colorIndex
			},
			handleStudentAvatarError(item, index) {
				this.$set(this.avatarLoadFailed, this.getStudentAvatarKey(item, index), true)
			},
			modifySource() {
				this.$util.post(
					"v2/school_job/modify_source", {
						user_id: this.userInfo.user_id,
					},
					(res) => {

					}
				);
			},

			download1() {
				window.open('https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/10/20/qxwq.pdf')
			},
			getgraduationDate() {
				let date = new Date(Date.now()).getFullYear() + '-09' + '-01 00:00:00'
				let timestamp = new Date(date).getTime()
				let nowtimestamp = Date.now()
				let arr = []
				let graduation = new Date(Date.now()).getFullYear().toString()
				if (nowtimestamp > timestamp) {
					arr.push(Number(graduation) + 1 + '届')
					arr.push(Number(graduation) + 2 + '届')
					arr.push(Number(graduation) + 3 + '届')
					arr.push(Number(graduation) + 4 + '届')
				} else {
					arr.push(Number(graduation) + '届')
					arr.push(Number(graduation) + 1 + '届')
					arr.push(Number(graduation) + 2 + '届')
					arr.push(Number(graduation) + 3 + '届')
				}
				// {
				// 		intr_name: "24届",
				// 		value: '1',
				// 	},
				// 	{
				// 		intr_name: "25届",
				// 		value: '2',
				// }
				// this.graduation_year = arr[0]

				let array = []
				arr.forEach((item, index, arr) => {
					array.push({
						intr_name: item,
						value: item,
					})
				})
				console.log(array)
				// let array = arr.push('2028届','2029届','2030届')
				// console.log(array)
				this.graduationDateList = array
				// console.log(this.graduationDateList)
			},


			// selectcityBox3(){
			// 	this.dialogVisibleMultipleChoice4 = true
			// },
			// multiple4(val) {
			// 	this.dialogVisibleMultipleChoice4 = false
			// 	this.work_city = val
			// 	
			// },
			changeScreen() {
				this.ispackUp = !this.ispackUp

			},
			genderChange() {
				// this.getUserRecordList()
			},
			selectcityBox6() {
				this.dialogVisibleMultipleChoice7 = true
			},
			multiple7(val) {
				this.dialogVisibleMultipleChoice7 = false
				this.is_skill_hobby = val

				// this.jobTitleList = val
				// this.getUserRecordList()
			},

			selectcityBox5() {
				this.dialogVisibleMultipleChoice6 = true
			},
			multiple6(val) {
				this.dialogVisibleMultipleChoice6 = false
				this.job_title = val

				this.jobTitleList = val
				// this.getUserRecordList()
			},

			selectcityBox4() {
				this.dialogVisibleMultipleChoice5 = true
			},
			multiple5(val) {
				this.dialogVisibleMultipleChoice5 = false
				this.education = val

				// this.getUserRecordList()
			},

			selectcityBox3() {
				this.dialogVisibleMultipleChoice4 = true
			},
			multiple4(val) {
				this.dialogVisibleMultipleChoice4 = false
				this.academy_feature = val
				console.log("academy_feature", val)

				// this.getUserRecordList()
			},

			selectcityBox2() {
				this.dialogVisibleMultipleChoice3 = true
			},
			multiple3(val) {
				this.dialogVisibleMultipleChoice3 = false
				this.work_city = val

				// this.getUserRecordList()
			},

			selectcityBox1() {
				this.dialogVisibleMultipleChoice2 = true
			},
			multiple2(val) {
				this.dialogVisibleMultipleChoice2 = false
				this.academy_name = val

				// this.getUserRecordList()
			},

			selectcityBox() {
				this.dialogVisibleMultipleChoice1 = true
			},
			multiple1(val) {
				this.dialogVisibleMultipleChoice1 = false
				this.city_name = val

				// this.getUserRecordList()
			},


			multipleClose() {
				this.multipleChange = false
			},
			searchWord(val) {
				this.college_type_list = val
			},
			multipleOpen() {
				this.multipleChange = true
			},
			multiple(val) {
				this.dialogVisibleMultipleChoice = false
				this.major_name = val

				// this.getUserRecordList()
			},
			cancel() {
				this.dialogVisibleMultipleChoice = false
				this.dialogVisibleMultipleChoice1 = false
				this.dialogVisibleMultipleChoice2 = false
				this.dialogVisibleMultipleChoice3 = false
				this.dialogVisibleMultipleChoice4 = false
				this.dialogVisibleMultipleChoice5 = false
				this.dialogVisibleMultipleChoice6 = false
				this.dialogVisibleMultipleChoice7 = false
			},
			selectMajorBox() {
				this.dialogVisibleMultipleChoice = true
			},


			openChatFrame(item) {

				this.$util.post(
					"v2/school_job/match_by_job_title", {
						admin_id: this.schoolInfo.admin_id,
						job_title: item.job_title ? JSON.stringify([item.job_title]) : '',
					},
					(res) => {

						if (res.code == 200) {
							let obj = {}
							if (res.data[0]) {
								obj = {
									job_id: res.data[0].id,
									admin_id: res.data[0].admin_id,
									user_id: item.user_id,
									to_chat_name: item.realname || item.username || item.username || '',
									to_chat_logo: item.avatar ||
										`https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2023/11/20/avatar_${(item.user_id*1)%26}.png`,
								}
							} else {
								obj = {
									job_id: 1,
									admin_id: this.schoolInfo.admin_id,
									user_id: item.user_id,
									to_chat_name: item.realname || item.username || item.username || '',
									to_chat_logo: item.avatar ||
										`https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2023/11/20/avatar_${(item.avatar.user_id*1)%26}.png`,
								}
							}

							this.$router.push({
								path: "/messageManagement",
								query: {
									obj: JSON.stringify(obj)
								},
							});
						}
					}
				);
			},
			reset() {
				this.jobTitleList = []
				this.job_title = []
				this.academy_feature = []
				this.major_name = []
				this.education = []
				this.gender = ''
				this.city_name = []
				this.academy_name = []
				this.is_current_year = ''
				this.graduation_year = ''
				this.is_just_chat = ''
				this.job_status = ''
				this.work_city = []
				this.searchName = ''
				this.currentpage = 1

				this.is_practice_experience = '1'
				this.is_social_experience = '1'
				this.is_skill_hobby = ['读书', '绘画', '写作']
				this.acceptance_of_overtime = '中等'
				this.acceptance_of_outwork = '中等(偶尔)'

				this.ques1 = [{
						name: '--开拓新业务:获得快速的结果、采取行动、喜好挑战',
						idx: 0,
						word: 'A'
					},
					{
						name: '--团队组织:热情乐观、采取行动、活跃团队气氛',
						idx: 1,
						word: 'B'
					},
					{
						name: '--运营优化:保证准确性、保持稳定性、对产品流程和细节精益求精',
						idx: 2,
						word: 'C'
					},
					{
						name: '--稳定执行:给予他人支持、团队精神、吃苦耐劳',
						idx: 3,
						word: 'D'
					},
				]
				this.ques2 = [{
						name: '--有话语权的职位、晋升、高薪、荣誉感、胜利感',
						idx: 0,
						word: 'A'
					},
					{
						name: '--友好密切的同事关系、团建活动、展现才艺的机会',
						idx: 1,
						word: 'B'
					},
					{
						name: '--发挥专业特长、获取新知识、高质量的工作成果',
						idx: 2,
						word: 'C'
					},
					{
						name: '--稳定的环境、较少的冲突、诚挚的感谢、合作互助的氛围',
						idx: 3,
						word: 'D'
					}
				]
				this.search()

			},
			isRequest(duration = 2000) {
				if (this.request) return true
				this.request = true
				setTimeout(() => {
					this.request = false
				}, duration)
				return false
			},
			search() {
				// if (this.isRequest()) return false
				this.searchName = this.searchName.replace(/%/g, '');
				// if(this.searchName=='%'){
				// 	this.$message.error("暂不支持%搜索，请重新输入");
				// 	return
				// }
				let obj = {
					// job_title: JSON.stringify(this.jobTitleList),//暂时注释

					academy_feature: JSON.stringify(this.academy_feature) == '[]' ? '' : JSON.stringify(
						this
						.academy_feature),
					major_name: JSON.stringify(this.major_name) == '[]' ? '' : JSON.stringify(this
						.major_name),
					education: JSON.stringify(this.education) == '[]' ? '' : JSON.stringify(this
						.education),
					gender: this.gender == '-1' || this.gender == '' ? '' : JSON.stringify([this.gender]),
					city_name: JSON.stringify(this.city_name) == '[]' ? '' : JSON.stringify(this
						.city_name),
					academy_name: JSON.stringify(this.academy_name) == '[]' ? '' : JSON.stringify(this
						.academy_name),
					is_current_year: this.is_current_year == '' ? '' : JSON.stringify(
						[this.is_current_year]),
					graduation_year: this.graduation_year,
					is_just_chat: this.is_just_chat == '' ? '' : JSON.stringify([this
						.is_just_chat
					]),
					job_status: this.job_status == '' ? '' : JSON.stringify([this
						.job_status
					]),
					work_city: JSON.stringify(this.work_city) == '[]' ? '' : JSON.stringify(this
						.work_city),
					// keyword: this.searchName,
				}
				if (this.searchName != '') {
					obj.keyword = this.searchName
				}
				this.currentpage = 1
				this.searchObj = obj
				this.getUserRecordList()

				this.dialogVisible = false
			},
			// search1(){
			// 	let obj = {
			// 		keyword: this.searchName,
			// 	}
			// 	this.searchObj = obj
			// 	this.getUserRecordList()
			// 	this.dialogVisible = false
			// },
			// getQrcode1() {
			// 	this.$util.post(
			// 		"v2/createNativeOrder", {

			// 		},
			// 		(res) => {
			// 			if (res.code == 200) {
			// 				// this.sceneId = res.data.scene
			// 				// this.setTimer()
			// 				// localStorage.setItem('qrcodeImg', res.data.qrCode)
			// 			}
			// 		}
			// 	);
			// },
			getQrcode() {
				this.$util.post(
					"admin/home/qrcode", {
						app_type: 10,
						page_path: 'pages/home/employmentDay',
						is_test: config.IS_TEST 
					},
					(res) => {
						if (res.code == 200) {
							this.qrcodeImg = res.data.qrCode
							// this.sceneId = res.data.scene
							// this.setTimer()
							// localStorage.setItem('qrcodeImg', res.data.qrCode)
						}
					}
				);
			},
			//获取学校列表
			remoteMethod(query) {
				// if (query != '') {
				this.$util.get(
					"v2/getKySchoolList", {
						sname: query
					},
					(res) => {

						if (res.code == 200) {
							let keyList = Object.keys(res.data)
							let arr = []
							keyList.forEach((item) => {
								arr.push(...res.data[item])
							})

							this.schoolList = arr
							return arr
						} else {
							this.schoolList = []
						}
					}
				);
				// }

			},
			//获取城市列表
			getCityList() {
				this.$util.get1(
					"https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2023/06/25/list_citys.json?0.17568012768125008", {},
					(res) => {

						let keyList = Object.keys(res)
						let arr = []
						keyList.forEach((item) => {
							arr.push(...res[item])
						})
						this.cityList = arr
					}
				);
			},
			screen() {
				this.dialogVisible = true
			},
			handleClose(done) {
				done();
			},
			//获取专业列表
			getcatalogall() {
				this.$util.post(
					"v2/major/getcatalogall", {
						type_code: '0',
						user_id: 0,
					},
					(res) => {

						if (res.code == 0) {

							let arr = []
							res.data.forEach((item) => {
								if (item.majors) {
									arr.push(...item.majors)
								}
							})

							this.majorList = arr
						}
					}
				);
			},
			// getCompanyInfo() {
			// 	this.$util.post(
			// 		"v2/school_job/getCompanyInfo", {
			// 			admin_id: this.schoolInfo.admin_id,
			// 		},
			// 		(res) => {
			// 			
			// 			if (res.code == 200) {
			// 				this.job_title = res.data.job_title
			// 				this.getUserRecordList()
			// 			}
			// 		}
			// 	);
			// },
			//获取生源列表
			getUserRecordList() {
				this.loading = true
				let url = ''
				if (!this.nextToken) {
					url = 'v2/school_job/user_record_list'
				} else {
					url = 'v2/pc/user_record_list'
				}
				this.$util.post(
					url, {
						page: this.currentpage,
						size: 12,
                        // job_status:JSON.stringify([4]), //固定4 获取简历测试环境
                         job_status:'', //固定4 获取简历测试环境
						...this.searchObj,

					},
					(res) => {
						if (res.code == 401) {
							console.log('请重新登录')
							// setTimeout(() => {
							// 	this.$router.replace({
							// 		path: '/login',
							// 	})
							// }, 10)
						}
						if (res.code == 200) {
							if (res.data.data) {
								let arr = res.data.data
								arr.forEach((item, index, arr) => {
									if (item.hobby && item.hobby !== '') {

										if (this.typeString(item.hobby)) {
											arr[index].hobbyList = (JSON.parse(item.hobby).s_by).splice(0, 3)
										} else {
											arr[index].hobbyList = item.hobby.split('、').splice(0, 3)
										}
									} else {
										arr[index].hobbyList = []
									}
									if (item.job_title) {
										if (this.typeString(item.job_title)) {
											arr[index].job_title = (JSON.parse(item.job_title)).toString()
										}
									}

								})
								this.recordList = arr

							} else {
								this.recordList = []
							}
							this.total = res.data.meta.total

						}
						this.loading = false
					},(err)=>{
						console.log(err)
						this.loading = false
					}
				);
			},
			typeString(str) {
				if (typeof str == 'string') {
					try {
						var obj = JSON.parse(str);
						// 等于这个条件说明就是JSON字符串 会返回true
						if (typeof obj == 'object' && obj) {
							return true;
						} else {
							//不是就返回false
							return false;
						}
					} catch (e) {
						return false;
					}
				}
				return false;
			},
			toInfo(id, source, user_id) {
				sessionStorage.setItem('source',source==2?1:0)
				sessionStorage.setItem('jobDetailsid',id)
				sessionStorage.setItem('jobDetailsuserid',user_id)
				this.$router.push({
					path: "/jobDetails",
					// query: {
						
					// },
				});

			},
			goSign() {
				// window.open('https://v.wjx.cn/vm/O0E3WQN.aspx#')
				let is_demo = sessionStorage.getItem('demo')
				if(is_demo){
					this.$router.push({
						path: '/meeting?demo='+is_demo,
					})
				}else{
					this.$router.push({
						path: '/meeting',
					})
				}
				
			},
			toCorporateImage() {
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {

					});
					return
				}

				this.$router.push({
					path: "/corporateImage",
					// query: {
					//   id: 1,
					// },
				});
			},
			toPushMessage() {
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {
				
					});
					return
				}
				this.$router.push({
					path: "/positionManagement",
					// query: {
					//   id: 1,
					// },
				});
			},
			toLiveManagement() {
				// if (!this.nextToken) {
				// 	this.$confirm('使用完整功能，请登录使用！', '提示', {
				// 		confirmButtonText: '去登录',
				// 		cancelButtonText: '取消',
				// 		type: 'warning'
				// 	}).then(() => {
				// 		this.$router.push({
				// 			path: '/login',
				// 			// query: {
				// 			//   id: 1,
				// 			// },
				// 		})
				// 	}).catch(() => {
				
				// 	});
				// 	return
				// }
				this.$router.push({
					path: "/meeting",
					// query: {
					//   id: 1,
					// },
				});
			},
			currentChange(page) {

				this.currentpage = page
				// this.getEnterpriseList()
				this.getUserRecordList()
			},
			previousPage() {
				if (this.currentpage > 1) {
					this.currentpage--
					this.getUserRecordList()
				}
			},
			nextPage() {
				if (!this.isNextPage) {
					this.currentpage++
					this.getUserRecordList()
				}
			},
			toCommentManagement() {
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {
				
					});
					return
				}
				this.$router.push({
					path: "/commentManagement",
					// query: {
					//   id: 1,
					// },
				});
			},

			change(event) {

			},
			start(event) {


			},
			move(event, orgin) {


			},
			end(event) {


			},


			change1(event) {

			},
			start1(event) {


			},
			move1(event, orgin) {


			},
			end1(event) {



			},

		},
	}
</script>
<style>
	.searchContainer .el-select {
		/* width: 248px !important; */
		flex: 1 !important;
	}

	.elDialog .el-select {
		flex: 1 !important;
	}

	#home .el-dialog__body {
		padding: 20px 20px 30px 20px;
		box-sizing: border-box;
	}

	#home .searchContainer .el-input__inner {
		height: 32px;
	}


	.functionality:hover {
		box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
		transform: translateY(-2px);
		transition: .2s all;
	}

	.homeList .item:hover {
		box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
		transform: translateY(-2px);
		transition: .2s all;
	}

	/* #home .listContainer .el-input__inner {
		background-color: #F0F4FA !important;
		color: #000;
	}

	#home .listContainer .el-tag.el-tag--info {
		background: #fff !important;
		border-color: #fff;
	} */

	/* #home .listContainer .el-input__inner::-moz-placeholder {
		color: #000;
	}

	#home .listContainer .el-input__inner::-ms-input-placeholder {
		color: #000;
	}

	#home .listContainer .el-input__inner::-webkit-input-placeholder {
		color: #000;
	} */

	#home .el-dialog__title {
		font-size: 16px !important;
		font-weight: bold !important;
	}

	.activityVideo {
		display: block;
		width: 100%;
		height:  460px;;
		object-fit: contain;
	}

	.activityVideoDialog .el-dialog__body {
		overflow: hidden;
	}

	#home .elDialog .el-input__inner {
		border: 1px solid #fff !important;

	}

	#home .elDialogBox .el-dialog__header {
		padding: 20px 30px 10px 30px !important;
	}


	#home .elDialog .el-input__inner {
		border: none !important;
		text-align: right !important;
		background: initial !important;
		/* font-size: 16px !important; */
	}

	#home .elDialog .el-select__input {
		border: none !important;
		text-align: right !important;
		background: initial !important;
		/* font-size: 16px !important; */
	}

	#home .elDialog .el-select {
		flex: 1;
	}

	#home .elDialog .el-select__tags {
		justify-content: flex-end;
	}

	/* #home .el-dialog {
		border-radius: 10px !important;
		margin-top: 50vh !important;
		transform: translateY(-50%);
	} */
</style>
<style lang="less" scoped>
	@media (max-width: 1599px) {
		.list {
			grid-template-columns: repeat(3, 1fr);
		}
	}

	@media (min-width: 1599px) {
		.list {
			grid-template-columns: repeat(4, 1fr);
		}
	}

	.drag {

		/* 根节点 */
		.content {
			width: 100%;
			max-height: 300px;
			// overflow-y: scroll;
			padding: 20px;
			background: #fff;
		}

		/* 列表样式,自行修改 */
		.row {
			background: rgb(241, 241, 241);
			padding: 10px;
			margin-bottom: 10px;
			border-radius: 10px;
			cursor: move;
			/* 鼠标手势 */
		}
	}


	.container {
		// width: 100vw;
		padding: 10px 10px 0 10px;
		background: #F0F4FA;

		.companyInfo {
			width: 100%;
			padding: 20px 0 20px 0;
			border-bottom: 1px solid #EEEEEE;
			font-size: 0;
			display: flex;
			align-items: center;
			margin-bottom: 25px;

			// img {
			// 	width: 57px;
			// 	height: 57px;
			// 	border-radius: 50%;
			// 	background: #003987;
			// 	margin-right: 10px;
			// }

			.companyInfoRight {
				display: flex;
				justify-content: center;
				flex-direction: column;

				.companyInfoName {
					font-weight: 500;
					font-size: 18px;
					color: #2D3C50;
					margin-bottom: 10px;
				}

				.tags {
					display: flex;
					align-items: center;

					.item {
						padding: 2px 4px;
						border-radius: 5px;
						border: 1px solid #AEAEAE;
						font-weight: 500;
						font-size: 12px;
						color: #AEAEAE;
						margin-right: 5px;
					}
				}
			}
		}

		.inCommonUse {
			padding: 15px 20px 15px 20px;
			min-width: 1110px;
			background: #fff;
			border-radius: 10px;
			margin-bottom: 10px;

			.head-title {
				position: relative;
				width: 100%;
				box-sizing: border-box;

				img {
					position: absolute;
					width: 268px;
					height: 35px;
					left: 80px;
					top: -6px;
					cursor: pointer;
				}
				.documentButton {
					position: absolute;
					right: 0;
					top: -4px;
					display: flex;
					align-items: center;
					gap: 8px;

					.activityIntroductionText {
						font-weight: bold;
						font-size: 14px;
						color: #2D3C50;
					}

					.activityAction {
						display: flex;
						align-items: center;
						justify-content: center;
						height: 26px;
						padding: 0 10px;
						border: 1px solid;
						border-radius: 5px;
						box-sizing: border-box;
						font-size: 14px;
						font-weight: bold;
						line-height: 1;
						cursor: pointer;
						text-decoration: none;

						img {
							position: static;
							width: 14px;
							height: 14px;
							margin-right: 4px;
						}
					}

					.schoolLink {
						color: #1677ff;
						background: #f2f8ff;
						border-color: #95c7ff;
					}

					.documentLink {
						color: #5a9b3d;
						background: #f4fff0;
						border-color: #a8d995;
					}

					.videoLink {
						color: #315ccf;
						background: #f1f5ff;
						border-color: #a7bdf9;
					}
				}
			}

			.title {
				color: #000;

				font-size: 16px;

				font-weight: bold;
				margin-bottom: 20px;
				// margin-left: 8px;
			}

			.optionContainer {
				width: 100%;
				display: flex;
				align-items: center;


				.qrCode {
					display: flex;
					align-items: center;
					font-size: 0;
					background: #E0EBFF;
					border-radius: 10px;
					padding: 5px;

					.qrCodeHint {
						font-size: 0;
						display: flex;
						align-items: center;
						flex-direction: column;
						margin-right: 10px;

						div {
							font-weight: 400;
							font-size: 7px;
							color: #677080;
						}

						img {
							width: 14px;
							height: 14px;
						}
					}

					.qrCodeImage {
						width: 74px;
						height: 74px;
						border-radius: 5px;
						// background: #003987;
					}
				}
			}

			.itemContainer {
				flex: 1;
				font-size: 0;
				// display: flex;
				// align-items: center;
				// justify-content: space-between;
				display: grid;
				grid-template-columns: repeat(4, 1fr);
				grid-gap: 20px 20px;
				// margin-right: 20px;



				.functionality {
					font-size: 0;
					width: 100%;
					min-width: 222px;
					height: 80px;
					background: linear-gradient(90deg, #B6FFFF, #E9FFFF);
					display: flex;
					align-items: center;
					justify-content: space-between;
					border-radius: 10px;
					cursor: pointer;
					padding: 15px;

					.left {
						font-size: 0;
						display: flex;
						align-items: center;
						margin-right: 10px;

						img {
							width: 42px;
							height: 59px;
							margin-right: 15px;
						}

						div {
							color: #333;

							font-size: 16px;

							font-weight: 500;
						}
					}

					.right {
						display: flex;
						align-items: center;

						div {
							font-weight: 500;
							font-size: 14px;
							color: #999999;
						}

						img {
							width: 11px;
							height: 11px;
						}
					}



				}

				.bg1 {
					background: linear-gradient(90deg, #E3E6FF, #F4F5FF);
				}

				.bg2 {
					background: linear-gradient(90deg, #D3F3FF, #ECFAFF);
				}

				.bg3 {
					background: linear-gradient(90deg, #FFEADD, #FFF8F4);
				}

				.bg4 {
					background: url('https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/10/10/ttt5.png') no-repeat;
					background-size: 100% 100%;
				}



				img {
					// width: 100%;
					width: 205px;
					height: 87px;
					// height: 165px;
					cursor: pointer;
				}
			}



		}


		.listContainer {
			// padding: 0 40px;

			.screen {
				padding: 15px 20px;
				border-radius: 10px;
				background: #fff;
				min-width: 1110px;
				margin-bottom: 10px;
			}

			.search {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-bottom: 15px;

				.title {
					color: #000;

					font-size: 16px;

					font-weight: bold;
					// margin-left: 8px;
				}

				.searchBox {
					background: #f0f4fa;
					display: flex;
					align-items: center;
					border-radius: 20px;
					padding: 8px 20px;

					.searchLeft {
						display: flex;
						align-items: center;
						font-size: 0;
						margin-right: 20px;

						img {
							width: 20px;
							height: 20px;
							margin-right: 10px;
						}

						input {
							width: 220px;
							font-size: 14px;
							background: #f0f4fa;
							border: none;
							outline: none;
						}
					}

					.searchRight {
						font-size: 14px;
						font-weight: 500;
						color: #1E40AF;
						cursor: pointer;
					}
				}

			}




			.screenContainer {
				// min-width: 1110px;
				// display: flex;
				// align-items: baseline;
				// margin-bottom: 10px;
			}


			.searchContainer {
				flex: 1;
				// display: flex;
				// align-items: center;
				// flex-wrap: wrap;
				margin-bottom: 20px;
				display: grid;
				grid-template-columns: repeat(3, 1fr);
				grid-gap: 16px 0px;

				.unfold {
					display: grid;
					grid-template-columns: repeat(6, 1fr);
					grid-gap: 20px 20px;
				}

				.searchItem {
					width: 100%;
					display: flex;
					align-items: center;
					// padding-right: 16px;
					padding-left: 16px;
					// margin-right: 10px;
					// margin-bottom: 10px;

					// background: #F0F4FA;

					.iptName {
						width: 122px;
						text-align: right;
						padding-right: 8px;
						color: #000;
						// font-family: -apple-system, system-ui, ui-sans-serif, Helvetica, Tahoma, Arial, "PingFang SC", 'Microsoft Yahei', 'Hiragino Sans GB', 'Hiragino Sans GB W3', STXihei, STHeiti, Heiti, SimSun, sans-serif !important;
						font-size: 14px;

						font-weight: 400;
					}

					.iptName-l {
						text-align: left;
						width: auto;

					}
				}

				.searchItem-p {
					padding-left: 0;
				}

			}

			.btnContainer {

				display: flex;
				align-items: center;
				padding-right: 15px;

				.btn {
					width: 92px;
					height: 39px;
					display: flex;
					align-items: center;
					justify-content: center;
					background: #FD8342;
					border-radius: 5px;
					font-size: 0;
					cursor: pointer;

					img {
						width: 16px;
						height: 16px;
						margin-right: 10px;
					}

					div {
						font-weight: 500;
						font-size: 14px;
						color: #FFFFFF;
					}
				}

				.reset {
					font-weight: 500;
					font-size: 14px;
					color: #1E40AF;
					margin-right: 30px;
					cursor: pointer;
				}

				.packUp {
					display: flex;
					align-items: center;
					font-weight: 500;
					cursor: pointer;

					div {
						font-weight: 500;
						font-size: 14px;
						color: #1E40AF;
						margin-right: 5px;
					}

					img {
						transition: 1s all;

					}
				}

			}

			.list {
				min-width: 1110px;
				// display: flex;
				// align-items: center;
				// flex-wrap: wrap;
				// justify-content: space-between;

				display: grid;
				// grid-template-columns: repeat(3, 1fr);
				grid-gap: 10px 10px;

				.item {
					min-width: 335px;
					max-width: 542px;
					flex: 1;
					background: #FFFFFF;
					border-radius: 10px;
					padding: 20px 25px;
					display: flex;
					justify-content: space-between;
					flex-direction: column;
					height: 281px;
					// margin: 0 10px 10px 0;

					.studentInfo {
						display: flex;
						align-items: center;
						// justify-content: space-between;
						margin-bottom: 5px;

						.left {
							flex: 1;

							.nameContainer {
								// display: flex;
								// align-items: center;
								// margin-bottom: 15px;

								.name {
									font-weight: bold;
									font-size: 16px;
									color: #000000;
									margin-right: 20px;
									margin-bottom: 5px;
								}

								.other {
									font-weight: 400;
									font-size: 14px;
									color: #6B7280;
								}
							}


						}

						.right {
							font-size: 0;
							margin-right: 10px;

							img,
							.studentAvatarText {
								width: 55px;
								height: 55px;
								border-radius: 50%;
								// background: #003987;
							}

							.studentAvatarText {
								display: flex;
								align-items: center;
								justify-content: center;
								overflow: hidden;
								font-size: 14px;
								font-weight: 500;
								line-height: 1;
								white-space: nowrap;
							}

							.studentAvatarText--0 { background: #e8eeff; color: #1765e6; }
							.studentAvatarText--1 { background: #fff4e5; color: #ff7629; }
							.studentAvatarText--2 { background: #e5f9ea; color: #27b866; }
							.studentAvatarText--3 { background: #f1eaff; color: #8957dc; }
							.studentAvatarText--4 { background: #ffe9ef; color: #e2567d; }
						}
					}

					.education {
						width: 100%;
						font-weight: bold;
						font-size: 14px;
						color: #333;
						margin-bottom: 5px;
					}

					.intentionContainer {
						margin-bottom: 10px;

						.intentionitem {
							display: flex;
							align-items: center;
							font-size: 0;

							img {
								width: 15px;
								height: 15px;
								margin-right: 5px;
								// margin-top: 2px;
							}

							div {
								font-weight: 500;
								font-size: 14px;
								color: #5A6374;
							}
						}
					}

					.skillTag {
						display: flex;
						align-items: center;
						margin-bottom: 10px;

						.tagItem {
							padding: 2px 7px;
							border-radius: 5px;
							font-weight: 500;
							font-size: 14px;
							color: #000;
							margin-right: 10px;
							background: #F3F4F6;
						}
					}

					.briefIntroduction {
						display: flex;
						align-items: center;
						margin-bottom: 5px;

						.briefIntroductionLeft {
							flex: 1;
							// margin-right: 30px;
							font-weight: 500;
							font-size: 14px;
							color: #5A6374;
							line-height: 22px;
							height: 45px;
						}


					}

					.briefIntroductionRight {
						background: #1E40AF;
						border-radius: 5px;
						width: 100%;
						height: 39px;
						text-align: center;
						line-height: 39px;
						font-weight: 500;
						font-size: 14px;
						color: #FFFFFF;

					}
				}
			}

			.paging {
				width: 100%;
				padding: 20px 0;
				display: flex;
				align-items: center;
				justify-content: space-between;

				.pagingLeft {
					display: flex;
					align-items: center;

				}
			}



		}


	}

	.elDialog {
		width: 100%;
		padding: 0 10px;

		// padding-top: 20px;
		.searchItem {
			display: flex;
			align-items: center;
			margin-bottom: 10px;
			border: 1px solid #D8DCE6;
			border-radius: 4px;
			padding: 0 15px;


			.iptName {
				// width: 80px;
				// text-align: right;
				font-weight: 400;
				font-size: 14px;
				color: #000;
				margin-right: 20px;
			}
		}

		.advanced {
			font-size: 16px;
			color: #333;
			font-weight: bold;
			margin-bottom: 20px;
			// margin-top: 30px;
		}
	}

	.btnContainer1 {
		// width: 700px;
		width: 100%;
		display: flex;
		justify-content: flex-end;
		margin-bottom: 10px;
		padding-right: 20px;

		.el-button--primary {
			// background-color: #0084FF !important;
			// border-color: #0084FF !important;
			// border-radius: 10px !important;
		}
	}



	.qrCode {
		display: flex;
		align-items: center;
		font-size: 0;
		background: #E0EBFF;
		border-radius: 10px;
		padding: 5px;

		.qrCodeHint {
			font-size: 0;
			display: flex;
			align-items: center;
			flex-direction: column;
			margin-right: 10px;

			div {
				font-weight: 400;
				font-size: 14px;
				color: #677080;
			}

			img {
				width: 14px;
				height: 14px;
			}
		}

		.qrCodeImage {
			width: 200px;
			height: 200px;
			border-radius: 5px;
			// background: #003987;
		}
	}


	.shortVideo {
		position: absolute;
		bottom: -15px;
		left: 50%;
		transform: translate(-50%);
		z-index: 30;

		width: 50px;
		text-align: center;
		font-size: 11px;
		font-weight: 400;
		color: #222222;
		border: 1px solid #FEA265;
		background: #FDF6E6;
		border-radius: 20px;
		padding: 5px 0;
	}

	.majorbox {
		flex: 1;
		width: 165px;
		border-radius: 4px;
		border: 1px solid #DCDFE6;
		cursor: pointer;
		display: flex;
		align-items: center;
		padding: 0 10px 0 15px;
		font-size: 14px;
	}

	.majorbox:hover {
		border: 1px solid #c0c4cc;
	}

	.majorBox {
		// width: 200px;
		height: 32px;
		line-height: 32px;
		font-size: 14px;
		color: #6B7280;
		flex: 1;

	}

	// .majorBox:hover {
	// 	border: 1px solid #c0c4cc;
	// }
	.majorBox1 {
		flex: 1;
		border-radius: 4px;
		// border: 1px solid #DCDFE6;
		width: 165px;
		height: 40px;
		padding: 0 5px 0 15px;
		line-height: 40px;
		font-size: 14px;
		color: #666;
		text-align: right;
		cursor: pointer;
	}

	.majorBox1:hover {
		// border: 1px solid #c0c4cc;
	}

	.banner {
		width: 100%;
		margin-bottom: 10px;
		min-width: 1110px;
		position: relative;
		cursor: pointer;

		img {
			width: 100%;
			border-radius: 10px;
		}

		.pdf {
			position: absolute;
			left: 50%;
			transform: translateX(-50%);
			bottom: 10px;
			width: 200px;
			height: 60px;
			z-index: 20;
			opacity: 0;
		}
	}
</style>
